const TestimonialsViewCard = ({ handleOpenDrawer }) => {
  return (
    <div className="col-span-12 my-4">
        <div className="flex justify-center items-center w-full">
            <div
                className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center justify-center w-[25%] gap-2"
            >
                <div className="mb-4">
                    <div className="w-[12vh] h-[12vh]  rounded-full flex items-center justify-center">
                    <img src="/images/Frame.png" alt="star" className="w-[9vh] h-[9vh]" />
                    </div>
                </div>
                <div className="text-[2vh] text-center font-medium">Add Institute Achievements</div>
                <div className="text-centerfont-medium text-gray-500 text-[1.8vh]">Maximum 5 Recognition Details</div>
                <button
                    onClick={() => handleOpenDrawer()}
                    className="w-[70%] py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-[2vh] font-medium"
                    style={{ color: "#fff" }}
                    type="button"
                >
                    Add Achievements
                </button>
            </div>
        </div>
    </div>
);
}
export default TestimonialsViewCard;